import { px, rect } from '../../../pixel/canvas';
import type { Part } from '../../types';

export const wingtips: Record<string, Part> = {
  wingtip_pod: {
    id: 'wingtip_pod',
    category: 'wingtip',
    name: 'Pod',
    requires: 'wingtip_pair',
    draw: (ctx, a, p) => { rect(ctx, a.x - 1, a.y, 2, 2, p.metalDark); px(ctx, a.x - 1, a.y, p.metal); px(ctx, a.x, a.y + 2, p.exhaustHot); },
  },
  wingtip_missile: {
    id: 'wingtip_missile',
    category: 'wingtip',
    name: 'Missile',
    requires: 'wingtip_pair',
    draw: (ctx, a, p) => { rect(ctx, a.x, a.y - 1, 1, 3, p.metal); px(ctx, a.x, a.y - 2, p.accent); px(ctx, a.x, a.y + 2, p.exhaust); },
  },
  wingtip_thruster: {
    id: 'wingtip_thruster',
    category: 'wingtip',
    name: 'Thruster',
    requires: 'wingtip_pair',
    draw: (ctx, a, p) => { rect(ctx, a.x - 1, a.y, 2, 1, p.metalDark); rect(ctx, a.x, a.y + 1, 1, 2, p.exhaust); px(ctx, a.x, a.y + 2, p.exhaustHot); },
  },
  wingtip_antenna: {
    id: 'wingtip_antenna',
    category: 'wingtip',
    name: 'Antenna',
    requires: 'wingtip_pair',
    draw: (ctx, a, p) => { rect(ctx, a.x, a.y - 4, 1, 5, p.metalDark); px(ctx, a.x, a.y - 4, p.accent); px(ctx, a.x, a.y - 2, p.metal); },
  },
  wingtip_bomb: {
    id: 'wingtip_bomb',
    category: 'wingtip',
    name: 'Bomb',
    requires: 'wingtip_pair',
    draw: (ctx, a, p) => { rect(ctx, a.x - 1, a.y, 2, 3, p.metalDark); rect(ctx, a.x - 1, a.y, 2, 1, p.metal); rect(ctx, a.x - 1, a.y + 2, 2, 1, p.dark); px(ctx, a.x, a.y + 1, p.accent); },
  },
  wingtip_light: {
    id: 'wingtip_light',
    category: 'wingtip',
    name: 'Light',
    requires: 'wingtip_pair',
    draw: (ctx, a, p) => { px(ctx, a.x, a.y, p.exhaustHot); rect(ctx, a.x, a.y + 1, 1, 1, p.metalDark); },
  },
  wingtip_spike: {
    id: 'wingtip_spike',
    category: 'wingtip',
    name: 'Spike',
    requires: 'wingtip_pair',
    draw: (ctx, a, p) => { rect(ctx, a.x, a.y - 3, 1, 4, p.metal); px(ctx, a.x, a.y - 4, p.metalDark); px(ctx, a.x, a.y - 1, p.accent); },
  },
  wingtip_claw: {
    id: 'wingtip_claw',
    category: 'wingtip',
    name: 'Claw',
    requires: 'wingtip_pair',
    draw: (ctx, a, p) => { px(ctx, a.x, a.y - 1, p.metalDark); rect(ctx, a.x - 1, a.y, 1, 3, p.metalDark); rect(ctx, a.x, a.y, 1, 3, p.metalDark); px(ctx, a.x - 1, a.y, p.metal); px(ctx, a.x, a.y, p.metal); px(ctx, a.x - 1, a.y + 2, p.accent); px(ctx, a.x, a.y + 3, p.accent); },
  },
  wingtip_gun: {
    id: 'wingtip_gun',
    category: 'wingtip',
    name: 'Gun',
    requires: 'wingtip_pair',
    draw: (ctx, a, p) => { rect(ctx, a.x - 1, a.y, 2, 3, p.metalDark); rect(ctx, a.x - 1, a.y, 2, 1, p.metal); rect(ctx, a.x, a.y - 2, 1, 2, p.metalDark); px(ctx, a.x - 1, a.y + 2, p.dark); },
  },
  wingtip_blade: {
    id: 'wingtip_blade',
    category: 'wingtip',
    name: 'Blade',
    requires: 'wingtip_pair',
    draw: (ctx, a, p) => { rect(ctx, a.x, a.y - 3, 1, 6, p.metalDark); px(ctx, a.x, a.y - 3, p.metalLight); px(ctx, a.x, a.y + 2, p.shadow); px(ctx, a.x, a.y, p.metal); },
  },
};
